/* unplugin-vue-components disabled */import script from "./lotteyTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./lotteyTabs.vue?vue&type=script&setup=true&lang=js"

import "./lotteyTabs.vue?vue&type=style&index=0&id=47ed8aee&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ed8aee"]])

export default __exports__